import { compose, lifecycle } from 'recompose';
import { connect } from 'react-redux';

import { filterOption } from '../modules';
import PieChartAnalytics from '../components/PieChartAnalytics';

const mapDispatchToProps = dispatch => ({
  filterOption(interaction, question, option, preview) {
    dispatch(filterOption(interaction, question, option, preview));
  },
});

const mapStateToProps = state => {
  return {
    // roles: _.get(state, 'auth.currentGroup.myRoles', 'default'),
  };
};

const enhance = compose(
  connect(
    mapStateToProps,
    mapDispatchToProps
  ),
  lifecycle({
    componentDidMount() {},
    componentDidUpdate() {},
  })
);

export default enhance(PieChartAnalytics);
